import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import "../Login/login.css";

const Signuprequest = () => {
  const [mobile, setMobile] = useState("");
  const [touched, setTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const navigate = useNavigate();

  const isMobileValid = mobile.length === 10 && /^\d{10}$/.test(mobile);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setApiError("");
    setTouched(true);
    if (!isMobileValid) return;
    setLoading(true);
    try {
      const data: any = await WebService.postAPI({
        action: "/v1/door-management/users/sign-up",
        body: { mobile_number: mobile },
      });
      if (data.status_code === 200) {
        navigate("/verifyOtp", { state: { mobile, type: "NEW_REGISTRATION" } });
      } else {
        setApiError(data.message || "Failed to send OTP. Try again.");
      }
    } catch (err: any) {
      setApiError(
        typeof err === "string"
          ? err
          : err?.message || "Network error. Please try again."
      );
    }
    setLoading(false);
  };

  return (
    <div
      className="login-bg"
      style={{
        background: `url(${process.env.PUBLIC_URL}/login.png) no-repeat left center/cover`,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "flex-end",
      }}
    >
      <div className="login-form-pane">
        <img src="/Assets/dm.png" alt="Logo" className="login-logo" />
        <h1
          style={{
            color: "#000",
            fontFamily: "Blanquotey, Arial, sans-serif",
            fontSize: "40.7px",
            fontWeight: 400,
            lineHeight: "normal",
            marginBottom: 0,
            marginTop: 8,
            letterSpacing: "0.5px",
          }}
        >
          Kunal Door AndMore
        </h1>
        <h2
          style={{
            fontFamily: "Poppins, Arial, sans-serif",
            fontSize: "32px",
            fontWeight: 600,
            lineHeight: "41px",
            marginBottom: "10px",
            marginTop: "6px",
            color: "#222",
          }}
        >
          Welcome to Kunal DoorAndMore
        </h2>
        <p className="login-subheading" style={{ marginBottom: 16 }}>
          Enter your mobile number to sign up
        </p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <input
            type="tel"
            className="login-input"
            placeholder="Enter your mobile number"
            value={mobile}
            maxLength={10}
            pattern="\d{10}"
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
            required
            autoFocus
            style={{
              marginBottom: 6,
              borderColor:
                touched && !isMobileValid ? "#e43e2d" : undefined,
              background: touched && !isMobileValid ? "#fff6f6" : undefined,
            }}
            aria-label="Mobile number"
            inputMode="numeric"
            onBlur={() => setTouched(true)}
          />
          {touched && !isMobileValid && (
            <div
              style={{
                color: "#e43e2d",
                fontSize: 13,
                marginBottom: 10,
                marginLeft: 2,
              }}
            >
              Please enter a valid 10-digit mobile number.
            </div>
          )}

          {apiError && (
            <div
              style={{
                color: "red",
                marginBottom: 10,
                fontSize: 13,
              }}
            >
              {apiError}
            </div>
          )}
          <button
            type="submit"
            className="login-btn"
            disabled={loading || !isMobileValid}
            style={{ marginBottom: 12 }}
          >
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate("/login")}
          style={{
            color: "#FFD400",
            background: "none",
            border: "none",
            textDecoration: "underline",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            marginTop: 10,
            marginLeft: 4,
          }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default Signuprequest;
